import React,{ useEffect , useState } from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import BatchLectures from './BatchLectures';
import BatchQuizes from './BatchQuizes';
import BatchNotes from './BatchNotes';
import BatchDpp from './BatchDpp';
import getAccess from '../../../utils/getAccess';


function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;


    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}
const BatchDetailsPanel = () => {
     const d = getAccess();
    const [value, setValue] = React.useState(0);
   
    
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider', }}>
                <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" sx={{ width: '100%', }}>
                    <Tab label="All Lectures" sx={{ width: '25%' }} {...a11yProps(0)} />
                     <Tab label="All Quiz" sx={{width : '25%'}} {...a11yProps(1)} />
                     <Tab label="All Note" sx={{width : '25%'}} {...a11yProps(2)} />
                     <Tab label="All DPP" sx={{width : '25%'}} {...a11yProps(3)} />
                </Tabs>
            </Box>
            <CustomTabPanel value={value} index={0}>
                 <BatchLectures />
            </CustomTabPanel>
           <CustomTabPanel value={value} index={1}>
               
                <BatchQuizes />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={2}>
                <BatchNotes />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={3}>
                <BatchDpp />
            </CustomTabPanel>
        </Box >
    );
}

export default BatchDetailsPanel